export const proveedores = [
	{
		"nombre": "Requisitos Proveedor Ampliación",
		"icono":"DatosContactoUnidad.png",
		"formatos": [
			{
				// "nombre": "Las personas físicas y morales interesadas.",
				// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
				// "html": "./Transparencia/htm/a69_f13_SC.htm"
			}
		],
		 "url" : "/interes/REQUISITOS PROVEEDOR AMPLIACION-FEBRERO26.pdf"
	},
	{
			"nombre": "Requisitos Proveedor Cambio de Accionistas",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
				 "url" : "/interes/REQUISITOS PROVEEDOR O CONTRATISTA CAMBIO DE ACCIONISTAS-FEBRERO26.pdf"
		},
		{
			"nombre": "Requisitos Proveedor Inscripción",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			"url" : "/interes/REQUISITOS PROVEEDOR INSCRIPCION-FEBRERO26.pdf"
		},

			{
			"nombre": "Aviso de Privacidad simplificado",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			"url" : "/interes/Aviso de Privacidad Simplificado.docx"
			},

			{
			"nombre": "Carta bajo protesta de decir verdad",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			"url" : "/interes/CARTA BAJO PROTESTA DE DECIR VERDAD.docx"
			},

			{
			"nombre": "Captura de datos.",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			"url" : "/interes/CAPTURA DE DATOS IPPCEH DGN.docx"
			},

			
	
]